import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import TooltipLabel from './Common/TooltipLabel';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['login', 'common']);

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Client-side validation (same as Login.aspx.cs)
    if (!email || !password) {
      setError('Username and password are required.');
      return;
    }

    setLoading(true);

    try {
      const result = await login(email, password);

      if (result.success) {
        // Role-based redirect (EXACT same logic as Login.aspx.cs lines 117-158)
        const userRole = result.user.role?.toUpperCase();

        switch (userRole) {
          case 'SUPERADMIN':
            navigate('/admin-dashboard');
            break;
          case 'HEADMASTER':
          case 'TEACHER':
            navigate('/school-dashboard');
            break;
          case 'PPD':
            navigate('/ppd-dashboard');
            break;
          case 'ADMIN':
            navigate('/admin-dashboard');
            break;
          default:
            // Default route or check Superuser flag
            navigate('/student-uniform');
            break;
        }
      } else {
        setError(result.message || 'Invalid username or password.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('An error occurred during login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Left Panel - Branding (EXACT same as Login.aspx lines 279-285) */}
        <div className="login-left">
          <div className="logo">
            <img src="/KTC.png" alt="KTC Logo" />
          </div>
          <h1>
            Kementerian Wanita, Kesihatan<br />
            dan Kesejahteraan Rakyat
          </h1>
          <p className="subtitle-main">Pengumpulan Data</p>
          <p>Pakaian Seragam & Kasut Pelajar</p>
        </div>

        {/* Right Panel - Form (EXACT same as Login.aspx lines 288-336) */}
        <div className="login-right">
          <h2 title={t('login:title', { lng: 'en' })}>{t('login:title')}</h2>
          <p className="subtitle" title={t('login:subtitle', { lng: 'en' })}>{t('login:subtitle')}</p>

          {/* Error Message */}
          {error && (
            <div className="message-label error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Username Field (same as Login.aspx lines 294-302) */}
            <div className="form-group">
              <TooltipLabel tKey="login:emailLabel" as="label" />
              <input
                type="text"
                className="form-control"
                placeholder="nama@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                disabled={loading}
              />
            </div>

            {/* Password Field (same as Login.aspx lines 305-314) */}
            <div className="form-group">
              <TooltipLabel tKey="login:passwordLabel" as="label" />
              <input
                type="password"
                className="form-control"
                placeholder="Masukkan kata laluan anda"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                disabled={loading}
              />
            </div>

            {/* Login Button (same as Login.aspx lines 321-324) */}
            <button
              type="submit"
              className="btn-login"
              disabled={loading}
              title={t('login:loginButton', { lng: 'en' })}
            >
              {loading ? t('login:loggingIn') : t('login:loginButton')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
